import * as React from 'react';
import { components } from 'react-select';
import { Glyphicon } from 'react-bootstrap';

type t = JSX.LibraryManagedAttributes<typeof components.DropdownIndicator, any>;

export const DropdownIndicator = (
    props: t
) => {
    return (
        <components.DropdownIndicator {...props}>
            <Glyphicon glyph="triangle-bottom" style={{ fontSize: 8 }} />
        </components.DropdownIndicator>
    );
};